import type { AppAccessControlContext } from '@frontend/components/agromarket/core/access-control'
import { applicationAccessControlList, createAccessControlProvider } from '@frontend/components/agromarket/core/access-control'
import type { TAppAccessControlList } from './types'

export const { AccessControlProvider: AppAccessControlProvider, useAccessControl: useAppAccessControl } = createAccessControlProvider<
  TAppAccessControlList,
  AppAccessControlContext
>(applicationAccessControlList)
